// extracted by mini-css-extract-plugin
export default {"brands":"Brands_brands__wpPQI","all-products-btn":"Brands_all-products-btn__y5y5J","brands-gallery":"Brands_brands-gallery__R-d1s"};